import { Heading2 } from "@/ui2/atoms/Heading";
import { ProfileSkeleton } from "@/features/profile/components/ProfileSkeleton";

import { AdminCalendarPreferencesCard } from "./components/AdminCalendarPreferencesCard";
import { AssociatedPracticeCard } from "./components/AssociatedPracticeCard";
import { BasicInfoCard } from "./components/BasicInfoCard";
import { ProfileSidebar } from "./components/ProfileSidebar";
import { useAdminProfile } from "./api/queries/useAdminProfile";

export function AdminProfile() {
  const { data: profileData } = useAdminProfile();

  // TODO: handle isError — when the query fails, profileData is undefined and this renders indefinitely
  if (!profileData) return <ProfileSkeleton />;

  return (
    <div className="tw:container tw:px-3">
      <Heading2 as="h1" className="tw:my-6!" size={3}>
        My Profile
      </Heading2>

      <div data-public="true">
        <div className="tw:flex tw:flex-col tw:gap-4 tw:md:flex-row">
          <div className="tw:md:w-1/4">
            <ProfileSidebar profileData={profileData} />
          </div>
          <div className="tw:flex tw:flex-col tw:gap-4 tw:md:w-3/4">
            <BasicInfoCard />
            <AdminCalendarPreferencesCard />
            <AssociatedPracticeCard />
          </div>
        </div>
      </div>
    </div>
  );
}
